import React, { ComponentType, useEffect } from 'react';
import { useNavigate, useLocation, useParams, useBlocker } from 'react-router-dom';

import ScreenBlockStatus from './ScreenBlockStatus';

function useNavigationBlocker(blockStatus: ScreenBlockStatus) {
    const blocker = useBlocker(({ currentLocation, nextLocation }) => {
        return blockStatus.status && currentLocation.pathname !== nextLocation.pathname;
    });

    return blocker;
}

interface WithNavigationBlockerProps {
    shouldBlock: ScreenBlockStatus | { status: false };
}

function withNavigationBlocker<P extends object>(
    WrappedComponent: ComponentType<P>
): ComponentType<P & WithNavigationBlockerProps> {
    return function (props: P & WithNavigationBlockerProps) {
        const blocker = useNavigationBlocker(props.shouldBlock);

        useEffect(() => {
            if (blocker.state === 'blocked') {
                const confirmLeave = window.confirm('You have unsaved changes. Are you sure you want to leave?');
                if (confirmLeave) {
                    blocker.proceed();
                } else {
                    blocker.reset();
                }
            }
        }, [blocker]);

        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();
        return <WrappedComponent {...props} navigate={navigate} location={location} pathvar={params} />;
    };
}

export default withNavigationBlocker;